import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RenderMarkdown } from 'MarkdownComponents';
import '../locales/streamDashboard/streamDashboard-en.json';
import { SidebarBox } from './SidebarBox';

type Props = {
    credits: string | null;
    className?: string;
};

export const CreditsBox: FC<Props> = ({ credits, className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!credits) return null;

    return (
        <SidebarBox caption={t('credits')} className={className}>
            <RenderMarkdown>{credits}</RenderMarkdown>
        </SidebarBox>
    );
};
